<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline">
        <label>Image:</label>
        <div class="input-group">
          <div class="input-file">
            <input
              type="file"
              placeholder="image"
              @change="onImageChange($event)"
            />
            <label class="custom-file-label">{{
              editCertification.fileName
                ? editCertification.fileName
                : "Choose file"
            }}</label>
          </div>
        </div>
      </div>
      <div class="form-inline" v-if="editCertification.url">
        <div class="input-group up-cret-img">
          <img :src="`${editCertification.url}`" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Description:</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="description"
            v-model="editDescription"
          />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Link:</label>
        <div class="input-group">
          <input type="text" placeholder="link" v-model="editLink" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Synonyms:</label>
        <div
          class="input-group input-prepend input-append"
          v-for="(synonym, index) in editSynonyms"
          :key="index"
        >
          <input
            type="text"
            placeholder="Synonym"
            v-model="editSynonyms[index]"
          />
          <a
            href="javascript:void(0)"
            class="input-prepend-btn"
            @click="addSynonym(index)"
          >
            <i class="material-icons-outlined align-middle">add</i>
          </a>
          <a
            href="javascript:void(0)"
            class="input-apend-btn"
            @click="deleteSynonym(index)"
          >
            <i class="material-icons-outlined align-middle">delete</i>
          </a>
        </div>
      </div>
      <div class="form-inline flex-row">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >{{ buttonLabel }}</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import * as database from "@/vendor/database";
import spinnerButton from "@/components/public/SpinnerButton";
import { storagePut, storageGetDownloadUrl } from "@/vendor/firebase";
import { randomString } from "@/utils/utils";

export default {
  props: ["propsData"],
  components: {
    spinnerButton,
  },
  data() {
    return {
      submitLoading: false,
      editDescription: null,
      editCertification: {},
      editLink: "",
      editSynonyms: [""],
    };
  },
  created: function () {
    this.initData();
  },
  watch: {
    propsData: function () {
      this.initData();
    },
  },
  methods: {
    initData: function () {
      this.editType = this.propsData.type;
      if (this.editType == "add") {
        this.panelTitle = "Add Certification";
        this.buttonLabel = "Add Certification";
      }
      if (this.editType == "edit") {
        this.panelTitle = "Edit Certification";
        this.buttonLabel = "Edit Certification";
      }
      this.editDescription = this.propsData.description;
      this.editLink = this.propsData.link;
      this.editCertification = {
        fileName: this.propsData.fileName,
        url: this.propsData.url,
      };
      this.editSynonyms =
        !this.propsData.synonyms || this.propsData.synonyms.length === 0
          ? [""]
          : this.propsData.synonyms;
    },
    freshSynonyms: function () {
      this.$forceUpdate();
    },
    addSynonym: function (index) {
      this.editSynonyms.splice(index + 1, 0, "");
      this.freshSynonyms();
    },
    deleteSynonym: function (index) {
      this.editSynonyms.splice(index, 1);
      if (this.editSynonyms.length == 0) {
        this.editSynonyms.push("");
      }
      this.freshSynonyms();
    },
    refreshEditCertification: function () {
      this.editCertification = {
        fileName: this.editCertification.fileName,
        file: this.editCertification.file,
        url: this.editCertification.url,
        new: this.editCertification.new,
      };
    },
    onImageChange: function (event) {
      const file = event.target.files[0];
      if (!file || !file.type.match("image.*")) {
        return;
      }
      this.editCertification = {};
      this.editCertification.fileName = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (arg) => {
        this.editCertification.file = file;
        // this.editCertification.fileData = arg.target.result;
        this.editCertification.url = arg.target.result;
        this.editCertification.new = true;
        this.refreshEditCertification();
      };
    },
    buttonClick: async function () {
      try {
        this.submitLoading = true;
        if (this.editDescription || this.editCertification) {
          const synonyms = this.editSynonyms.filter((item) => item);
          const data = {
            description: this.editDescription,
            link: this.editLink,
            synonyms,
          };
          if (
            this.editCertification &&
            this.editCertification.new &&
            this.editCertification.file
          ) {
            let fileType = this.editCertification.file.type.split("/")[1];
            fileType = fileType == "jpeg" ? "jpg" : fileType;
            const fileName = randomString(10) + "." + fileType;
            await storagePut("images/", fileName, this.editCertification.file);
            const getResult = await storageGetDownloadUrl("images/" + fileName);
            data.fileName = fileName;
            data.url = getResult.data;
          } else if (this.editCertification && !this.editCertification.new) {
            data.fileName = this.editCertification.fileName;
            data.url = this.editCertification.url;
          }
          if (this.editType === "add") {
            database
              .addDoc("certifications", data)
              .then((result) => {
                if (result.ok) {
                  this.$toasted.global.toast_success({
                    message: "add success",
                  });
                  this.$emit("closePanel");
                } else {
                  this.$toasted.global.toast_error({ message: "add error" });
                }
              })
              .catch((error) => {
                this.$toasted.global.toast_error({ message: error });
              })
              .finally(() => {
                this.submitLoading = false;
              });
          } else if (this.editType === "edit") {
            database
              .updateDocById("certifications", this.propsData.id, data)
              .then((result) => {
                if (result.ok) {
                  this.$toasted.global.toast_success({
                    message: "edit success",
                  });
                  this.$emit("closePanel");
                } else {
                  this.$toasted.global.toast_error({ message: "edit error" });
                }
              })
              .catch((error) => {
                this.$toasted.global.toast_error({ message: error });
              })
              .finally(() => {
                this.submitLoading = false;
              });
          }
        }
      } catch (error) {
        this.submitLoading = false;
        this.$toasted.global.toast_error({ message: "error" });
      }
      this.submitLoading = false;
    },
  },
};
</script>
